import { jsx as _jsx } from "react/jsx-runtime";
import SeeWhatItsLike from '~/components/SeeWhatItsLike';
import { useLocaleKeys } from '~/i18n';
import img1 from './1.png';
import img2 from './2.png';
import img3 from './3.png';
export default function ServiceLibrarySeeWhatItsLike() {
    const { t } = useLocaleKeys('pages.servicesPage.seeWhatItsLike');
    return /*#__PURE__*/ _jsx(SeeWhatItsLike, {
        steps: [
            {
                title: t.step1Title(),
                subtitle: t.step1Subtitle(),
                image: {
                    src: img1,
                    height: 1246,
                    width: 702
                }
            },
            {
                title: t.sendUltimateProposal(),
                subtitle: t.step2Subtitle(),
                image: {
                    src: img2,
                    height: 1246,
                    width: 748
                }
            },
            {
                title: t.getApprovedFaster(),
                subtitle: t.step3Subtitle(),
                image: {
                    src: img3,
                    height: 1246,
                    width: 748
                }
            }
        ]
    });
}
